<template>
  <div
    class="filters__option"
    :class="{
      'filters__option--active': term.active,
      'disabled': term.cross_count === 0,
    }">
    <div class="filters__option__tick" @click="$emit('change')"></div>
    {{ term.name }} ({{ term.cross_count }})
    {{ this.term.children && this.term.children.length ? "..." : "" }}
  </div>
</template>

<script>
export default {
  name: "checkbox",
  components: {},
  props: {
    term: Object,
    _expand : false
  },
  data() {
    return {};
  },
  mounted() {
  },
  computed: {
    showChildren() {

    }
  },
  emits: ["change"],
  watch: {},
  methods: {}
};
</script>
